"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _defaultTab = _interopRequireDefault(require("./defaultTab"));

var _classicTab = _interopRequireDefault(require("./classicTab"));

var _widgetTab = _interopRequireDefault(require("./widgetTab"));

require("./tab.css");

var Tab = function Tab(props) {
  var variant = props.variant;

  switch (variant) {
    case "widget":
      return /*#__PURE__*/_react["default"].createElement(_widgetTab["default"], props);

    case "classic":
      return /*#__PURE__*/_react["default"].createElement(_classicTab["default"], props);

    default:
      return /*#__PURE__*/_react["default"].createElement(_defaultTab["default"], props);
  }
};

Tab.propTypes = {
  variant: _propTypes["default"].oneOf(["classic", "default", "widget"])
};
Tab.defaultProps = {
  variant: "default"
};
Tab.displayName = "OrionTab";
var _default = Tab;
exports["default"] = _default;